import './Button.scss';
import PropTypes from 'prop-types';
import { PreservedLink as Link } from './PreservedLink';

const Button = ({
  id,
  variant = 'filled',
  type = 'button',
  link = '',
  is_external = false,
  onClick,
  children,
  className = '',
  color = 'primary',
  disabled = false,
  ...rest
}) => {
  const classes = `default-btn ${className} ${variant} bg-${color}`;

  if (type === 'submit' || type === 'button') {
    return (
      <button
        id={id}
        type={type}
        disabled={disabled}
        className={classes}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    );
  }

  if (type === 'link' && link && is_external) {
    return (
      <a
        id={id}
        href={link}
        className={classes}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Link id={id} to={link} className={classes} onClick={onClick} {...rest}>
      {children}
    </Link>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  variant: PropTypes.oneOf(['filled', 'outlined', 'icon']).isRequired,
  type: PropTypes.oneOf(['link', 'button', 'submit']).isRequired,
  color: PropTypes.oneOf(['primary', 'secondary']),
  is_external: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Button;
